import { render, staticRenderFns } from "./mdc-image-list-item.vue?vue&type=template&id=3d1c3e4f&"
import script from "./mdc-image-list-item.vue?vue&type=script&lang=ts&"
export * from "./mdc-image-list-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports